import type { ApiAvailableTime } from '@app/packages/api/v2/types/entities'
import type { AvailableTimesPutRequestItem } from '@app/packages/api/v2/types/params'

import { AvailabilityRule } from './AvailabilityRule'
import type { Moment } from './moment'

export const apiAvailableTimeToAvailabilityRule = (rule: ApiAvailableTime) => {
  return AvailabilityRule.parseIcs(
    [
      'BEGIN:AVAILABLE',
      `DTSTART;${rule.attributes.dtstart}`,
      `DTEND;${rule.attributes.dtend}`,
      rule.attributes.rrule ? `RRULE:${rule.attributes.rrule}` : '',
      'END:AVAILABLE',
    ]
      .filter(l => !!l)
      .join('\n')
  )
}

export const availabilityRuleToApiAvailableTime = (rule: AvailabilityRule): AvailableTimesPutRequestItem => {
  const serialized: AvailableTimesPutRequestItem = {
    dtstart: `TZID=${rule.start.tz()}:${rule.start.format('YYYYMMDDTHHmmss')}`,
    dtend: `TZID=${rule.end.tz()}:${rule.end.format('YYYYMMDDTHHmmss')}`,
  }

  // The rrule holds UNTIL on the browser's clock; rruleString writes back the instant itself.
  if (rule.repeats && rule.rruleString) serialized.rrule = rule.rruleString.replace('RRULE:', '')

  return serialized
}

export const mergeSlots = (rules: AvailabilityRule[]) => {
  const merged: { id: string; start: Moment; end: Moment }[] = []
  rules.forEach(rule => {
    const last = merged[merged.length - 1]
    if (last && last.end.format('HH:mm') === rule.start.format('HH:mm')) {
      last.end = rule.end.clone()
    } else {
      merged.push({
        id: rule.id,
        start: rule.start.clone(),
        end: rule.end.clone(),
      })
    }
  })
  return merged
}

export const isWholeDay = (matches: { start: Moment; end: Moment }[]) => {
  return matches.length === 1 && matches[0].start.format('HH:mm') === '00:00' && matches[0].end.format('HH:mm') === '00:00'
}
